import React, { useEffect } from 'react';

import NavBar from '../Common/Navbar';
import Hero from '../Home/Hero';
import Cards from '..//Home/Cards';
import Clients from '..//Home/Clients';
import AboutUs from '..//Home/AboutUs';
import Portfolio from '..//Home/Portfolio';
import Gallery from '..//Home/Gallery';
import Services from '..//Home/Services';
import ServicesCard from '..//Home/ServicesCard';
import Experience from '..//Home/Experience';
import ExperienceContent from '..//Home/ExperienceContent';
import Work from '..//Home/Work';
import Testimonial from '..//Home/Testimonial';
import OurTeam from '..//Home/OurTeam';
import Pricing from '..//Home/Pricing';
import Faq from '..//Home/Faq';
import Blogs from '..//Home/Blogs';
import Footer from '../Common/Footer';
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '..//Home/TopButton';
import Speciality from '..//Home/Speciality';


function Home() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className='header-index'>
                <NavBar />
                <Hero />
            </div>
            <Cards />
            <Clients />
            <div className='about-home'>
                <AboutUs />
            </div>
            <Portfolio />
            <Gallery />
            <div style={{ background: '#3D0F41', padding: '0 0 120px 0' }}>
                <Services />
                <ServicesCard />
            </div>
            <div className='experience'>
                <Experience />
                <ExperienceContent />
            </div>
            <Work />
            <Testimonial />
            <Speciality />
            <div className='team'>
                <OurTeam />
            </div>
            {/* <Pricing /> */}
            <Faq />
            {/* <Blogs /> */}
            <div className='footer'>
                <Footer />
                <FooterMenu className='footer-mar' />
                <Copyright />
            </div>
            <TopButton />

        </>
    );
}

export default Home;
